import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import useTimesheetFields from '@ubeya/shared/hooks/account/useTimesheetFields';
import { SEQUENCE_FIELDS_TYPE } from '@ubeya/shared/constants/sequences';
import { ReactComponent as BaseInfoIcon } from '@ubeya/shared-web/assets/explanation.svg';
import { CheckBoxField } from '../FormFields';
import FormModal from '../FormModal';
import ConfigContext from '../../contexts/ConfigContext';

const Text = styled.div`
  margin: 0 0 10px 20px;
`;

const BottomLink = styled.a`
  margin: 20px 0 0 20px;
`;

const InfoIcon = styled(BaseInfoIcon)`
  width: 15px;
  height: 15px;
  margin-right: 8px;
`;

const TimesheetInputModal = ({ accountId, onClose, onConfirm, initialValues }) => {
  const { t } = useContext(ConfigContext);

  const { fields, mappedFields: mappedTimesheetFields } = useTimesheetFields();
  const fieldsNotDeleted = useMemo(() => (fields || []).filter(({ deletedAt }) => !deletedAt), [fields]);

  return (
    <FormModal
      initialValues={initialValues}
      validate={(values) =>
        Object.entries(values || {}).filter(([, value]) => !!value).length > 0 ? undefined : { required: true }
      }
      onSubmit={(values) => {
        const selectedFields = Object.entries(values || {})
          .filter(([, value]) => !!value)
          .map(([key]) => {
            const id = parseInt(key.replace('timesheet-field-', ''), 10);
            const field = mappedTimesheetFields[id];
            if (!field) return null;
            return {
              name: t(field.slug),
              ...field,
              isRequired: false,
              type: SEQUENCE_FIELDS_TYPE.TIMESHEET_FIELD
            };
          })
          .filter(Boolean);

        onConfirm(selectedFields);
        onClose();
      }}
      onClose={onClose}
      size="small"
      title={t('timesheetField')}
      confirmText={initialValues ? 'update' : 'add'}
      disabledOnInvalid>
      <Text>
        <InfoIcon />
        {t('timesheetFieldTooltip')}
      </Text>

      {fieldsNotDeleted?.length > 0 ? (
        fieldsNotDeleted.map(({ id, isGeneric, name, slug }) => (
          <CheckBoxField key={id} name={`timesheet-field-${id}`} title={isGeneric ? t(slug) : name} />
        ))
      ) : (
        <BottomLink href={`${accountId}/settings/account/timesheet-fields`} target="_blank">
          {t('addFirstTimesheetField')}
        </BottomLink>
      )}
    </FormModal>
  );
};

export default TimesheetInputModal;
